/**
 * use-payment-offers — paymentOffersApi（ADM-PAY-S005 运营支付活动 offer CRUD）
 *
 * 每方法一次 apiRequest（client 自动带 JWT + X-Request-Id + 解 envelope；code!=='OK' 抛 AdminApiError）；
 * 请求/响应类型全取 @novel-admin/shared（禁 web 侧重定义）。offer **全写 operator+**（不像 product_metadata
 * 把 activate/deactivate/remove 收窄 root/admin）——hook 层无 RBAC 逻辑，UI gate canWrite + 后端 requireRole 权威。
 * list 是 offset 分页壳 {data,total,page,limit,hasMore} → apiRequestOffsetPaged；DELETE 返 { id, deleted_at }。
 */

import type {
  CreatePaymentOfferRequest,
  PaymentOfferResponse,
  UpdatePaymentOfferRequest,
} from '@novel-admin/shared';
import type {
  PaymentOfferProductOrderResponse,
  ReplacePaymentPageProductOrderRequest,
} from '@novel-admin/shared/schemas/payment-product-order';
import { apiRequest, apiRequestOffsetPaged } from '~/api/client';

export const paymentOffersApi = {
  getProductOrder: (id: string) =>
    apiRequest<PaymentOfferProductOrderResponse>({
      method: 'GET',
      path: `/api/v1/payment-offers/${id}/product-order`,
    }),
  replaceProductOrder: (id: string, body: ReplacePaymentPageProductOrderRequest) =>
    apiRequest<PaymentOfferProductOrderResponse>({
      method: 'PUT',
      path: `/api/v1/payment-offers/${id}/product-order`,
      body,
    }),
  /** 列某 App 运营支付活动（offset 分页 + 可选 is_active 过滤；undefined 过滤项 client 自动省略不发）*/
  list: (params: { app_id: string; is_active?: boolean; page?: number; limit?: number }) =>
    apiRequestOffsetPaged<PaymentOfferResponse>({
      method: 'GET',
      path: '/api/v1/payment-offers',
      query: {
        app_id: params.app_id,
        is_active: params.is_active,
        page: params.page,
        limit: params.limit,
      },
    }),
  create: (body: CreatePaymentOfferRequest) =>
    apiRequest<PaymentOfferResponse>({ method: 'POST', path: '/api/v1/payment-offers', body }),
  update: (id: string, body: UpdatePaymentOfferRequest) =>
    apiRequest<PaymentOfferResponse>({
      method: 'PATCH',
      path: `/api/v1/payment-offers/${id}`,
      body,
    }),
  activate: (id: string) =>
    apiRequest<PaymentOfferResponse>({
      method: 'POST',
      path: `/api/v1/payment-offers/${id}/activate`,
    }),
  deactivate: (id: string) =>
    apiRequest<PaymentOfferResponse>({
      method: 'POST',
      path: `/api/v1/payment-offers/${id}/deactivate`,
    }),
  remove: (id: string) =>
    apiRequest<{ id: string; deleted_at: string }>({
      method: 'DELETE',
      path: `/api/v1/payment-offers/${id}`,
    }),
};
